import { Typography } from "@/Components/v2/atoms/Typography";
import { Grid } from "@/Components/v2/atoms/Grid";
import { colors } from "@/Components/v2/utils/brand-colors";
import { Box as MuiBox } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Divider } from "@/Components/v2/atoms/Divider";

type ProgressInfo = {
  title: string;
  value: string;
};

type ProgressCardProps = {
  title: string;
  progressText: string;
  progress: number;
  info: ProgressInfo[];
  isCompleted?: boolean;
};

const ProgressCard = ({
  title,
  progressText,
  progress,
  info,
  isCompleted = false,
}: ProgressCardProps) => {
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    setAnimatedProgress(progress);
  }, [progress]);

  return (
    <MuiBox
      sx={{
        border: (theme) =>
          `1px solid ${theme.palette.mode === "dark" ? colors.grayBorder : colors.dropdownBorder}`,
        borderRadius: "1rem",
        padding: "1.5rem",
      }}
    >
      <Typography
        variant="h6"
        fontSize={16}
        fontWeight={600}
        sx={{
          mb: 2,
        }}
      >
        {title}
      </Typography>
      <Typography fontSize={14} fontWeight={600}>
        {progressText}
      </Typography>
      <MuiBox
        mt={0.5}
        mb={3}
        width="100%"
        height="8px"
        borderRadius="4px"
        overflow="hidden"
        position="relative"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? colors.lightGray : "#E0E0E0",
        }}
      >
        <MuiBox
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: `${animatedProgress}%`,
            backgroundColor: (theme) => (isCompleted ? theme.palette.success.main : "#6C5CE7"),
            borderRadius: "4px",
            transition: "width 1.2s ease-in-out",
          }}
        />
      </MuiBox>
      <Divider sx={{ marginX: "-1.5rem" }} />

      <Grid container rowSpacing={0.5} columnSpacing={1.5} mt={2}>
        {info.map((item, index) => (
          <React.Fragment key={`info-${index}`}>
            <Grid item xs={5} key={`title-${index}`}>
              <Typography variant="body2" fontSize={14}>
                {item.title}:
              </Typography>
            </Grid>
            <Grid item xs={7} key={`value-${index}`}>
              <Typography variant="body1" fontSize={14} fontWeight={600}>
                {item.value}
              </Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </MuiBox>
  );
};

export default ProgressCard;
